import { z } from 'zod';
const VALID_LEVELS = ['trace', 'debug', 'info', 'warn', 'error', 'fatal'];
/**
 * Shared schema for GET /api/system/logs query parameters.
 * Moved from system.controller.ts (local logsQuerySchema) to shared for
 * validate() middleware + getValidatedQuery() usage (gh#750 batch-1).
 */
export const systemLogsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(2000).optional(),
    since: z.coerce.number().int().min(0).optional(),
    level: z.enum(VALID_LEVELS).optional(),
    filter: z.string().max(200).optional(),
    reqId: z.string().max(120).optional(),
    module: z.string().max(120).optional(),
});
//# sourceMappingURL=system.schema.js.map